import React, { useEffect } from "react";
// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import Settings from "./components/settings";
import RtlLayout from "./components/RtlLayout";
import ScrollToTop from "./components/ScrollToTop";
import { ProgressBarStyle } from "./components/ProgressBar";
import ThemeColorPresets from "./components/ThemeColorPresets";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import { AuthProvider } from "./contexts/AuthProvider";
import UserActivityDetector from "./UserActivityDetector";
import { useTwilioClient } from "./hooks/useTwilioClient";
import { useAuthStore } from "./stores/useAuthStore";

// ----------------------------------------------------------------------

export default function App() {
  // useEffect(() => {
  //   const clearLocalStorage = () => {
  //     sessionStorage.clear();
  //   };
  //   window.addEventListener("unload", clearLocalStorage);
  //   return () => {
  //     window.removeEventListener("unload", clearLocalStorage);
  //   };
  // }, []);

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <RtlLayout>
          <MotionLazyContainer>
            <ProgressBarStyle />
            <Settings />
            <ScrollToTop />
            <AuthProvider>
              <Router />
              <UserActivityDetector />
            </AuthProvider>
          </MotionLazyContainer>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
